import { AlertVariants } from "./constants";
import styled, { css } from "styled-components";
import { ids } from "@icarros/theme-react";
const { color, size } = ids || {};
const getVariantStyle = (variant) => {
    switch (variant) {
        case AlertVariants.neutral:
            return css `
        border: ${size.border_width.ids_size_border_small} solid
          ${color.feedbacks.ids_color_feedback_neutral};
      `;
        case AlertVariants.success:
            return css `
        border: ${size.border_width.ids_size_border_small} solid
          ${color.feedbacks.ids_color_feedback_success};
      `;
        case AlertVariants.error:
            return css `
        border: ${size.border_width.ids_size_border_small} solid
          ${color.feedbacks.ids_color_feedback_error};
      `;
        default:
            return css `
        border: ${size.border_width.ids_size_border_small} solid
          ${color.feedbacks.ids_color_feedback_neutral};
      `;
    }
    return;
};
export const StyledAlertContainer = styled.div `
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-evenly;
  background: ${color.backgrounds.ids_color_bg_base};
  ${({ variant }) => getVariantStyle(variant)}
  border-radius: ${size.corner_radius.ids_size_cornerRadius_card_02};
`;
export const StyledLabelContainer = styled.div `
  display: flex;
  flex-direction: column;
`;
export const StyledBodyContainer = styled.div `
  display: flex;
  flex-direction: column;
`;
export const StyledIconContainer = styled.div `
  padding: ${size.general.ids_size_general_16x};
`;
export const StyledCloseIconContainer = styled.div `
  vertical-align: top;
  height: 75px;
`;
export const StyledTextContainer = styled.div `
  display: flex;
  flex-direction: column;
  padding: ${size.general.ids_size_general_16x} 0;
  flex-grow: 1;
`;
//# sourceMappingURL=Alert.style.js.map